export default {
  "items.title": "Items & Services",
  "items.subtitle": "Manage the available items and their prices",
  "items.add": "Add item",
  "items.add.title": "Add item",
  "items.edit.title": "Edit item",

  "items.duration.title": "Execution duration",
  "items.duration.normal": "Normal execution",
  "items.duration.urgent": "Urgent execution",
  "items.duration.unit": "hrs",
  "items.duration.notSet": "Not set yet",
  "items.duration.note": "Durations apply to all orders and start when the laundry actually receives the order.",
  "items.duration.settings": "Duration settings",
  "items.duration.scope": "Durations apply to the whole laundry, not per item.",

  "items.table.item": "Item",
  "items.table.status": "Item status",
  "items.table.actions": "Actions",

  "items.service.wash_only": "Wash only",
  "items.service.iron_only": "Iron only",
  "items.service.wash_iron": "Wash & iron",

  "items.price.normal": "Normal",
  "items.price.urgent": "Urgent",
  "items.price.unavailable": "Unavailable",

  "items.status.active": "Active",
  "items.status.inactive": "Disabled",

  "items.action.edit": "Edit",
  "items.action.deactivate": "Disable",
  "items.action.activate": "Enable",
  "items.action.delete": "Delete",

  "items.form.itemData": "Item details",
  "items.form.name": "Item name",
  "items.form.image": "Illustrative image",
  "items.form.services": "Services & prices",
  "items.form.serviceAvailable": "Service available for this item",
  "items.form.normalPrice": "Normal price",
  "items.form.urgentPrice": "Urgent price",
  "items.form.serviceNote": "Disabling a service applies to this item only and does not affect other items.",
  "items.form.save": "Save item",
  "items.form.saveEdit": "Save changes",
  "items.form.cancel": "Cancel",

  "items.confirm.deactivate.title": "Disable item?",
  "items.confirm.deactivate.text": "This item will not be shown to customers while disabled.",
  "items.confirm.deactivate.confirm": "Disable item",
  "items.confirm.delete.title": "Delete item?",
  "items.confirm.delete.text": "Do you want to delete this item from the items list?",
  "items.confirm.delete.confirm": "Delete item",

  "items.toast.added": "Item added",
  "items.toast.updated": "Changes saved",
  "items.toast.activated": "Item enabled",
  "items.toast.deactivated": "Item disabled",
  "items.toast.deleted": "Item deleted",

  "items.empty.title": "No items added yet",
  "items.empty.text": "Add the items the laundry provides its services on",
  "items.empty.action": "Add item",

  "items.error": "Could not load items",
  "items.errorSave": "Could not save the item, please try again.",

  "items.image.choose": "Choose image",
  "items.image.replace": "Replace image",
  "items.image.remove": "Remove image",
  "items.image.none": "No image added",
  "items.image.optional": "Optional",
  "items.image.hint": "Format and size follow the system settings.",

  "items.required.name": "Item name is required",
  "items.invalid.price": "Enter a valid non-negative number",
  "items.form.errorFix": "Please fix the required fields before saving.",

  "items.demoNote": "This is a preview with demo data."
};